import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import DatePicker from 'material-ui/DatePicker';
import IconButton from 'material-ui/IconButton';
import SvgIcon from 'material-ui/SvgIcon';
import Snackbar from 'material-ui/Snackbar';
import Slider from 'material-ui/Slider';

import { addProduct } from '../../actions/productActions';


import {
  Container,
  FormContainer,
  FormGroup,
  FormTitle,
  Pre,
  Code
} from '../Styles/index';

class CreateProduct extends Component {

  state = {
    product_code: '',
    product_name: '',
    pcscase: '',
    product_quantity: 0,
    price_item: 0,
    rimbursimi: '',
    pa: '',
    categories: '',
    zbritje: 0,
    tvsh: '',
    skadenca: '',
    parent_category: '',
    is_active: false,
    openSnackBar: false,
    hasError: false,
  }

  _handleChange = event => {
    if (event.target.name === 'product_quantity') {
      this.setState({
        [event.target.name]: parseInt(event.target.value, 10)
      });
      return
    }

    if (event.target.name === 'price_item') {
      this.setState({
        [event.target.name]: parseFloat(event.target.value)
      });
      return
    }

    this.setState({
      [event.target.name]: event.target.value
    });
  }

  _handleChangeZbritje = event => {
    let value;

    if (event.target.value > 100) {
      value = 100
    }
    else if (event.target.value < 0) {
      value = 0;
    }else {
      value = parseInt(event.target.value, 10);
    }

    this.setState({
      [event.target.name]: value
    });
  }

  _handleBlur = event => {
    if (event.target.value.trim() === '') {
      this.setState({
        [event.target.name]: 0
      });
    }
  }

  _handleSliderChange = (event, newValue) => {

    this.setState({
      zbritje: newValue * 100 | 0
    })

  }

  _handleCheck = (event, checked) => {
    this.setState({
      [event.target.name]: checked
    });
  }

  _handleSubmit = event => {
    event.preventDefault();
    this.props.addProduct({
      data: {
        product_code: this.state.product_code,
        product_name: this.state.product_name,
        pcscase: this.state.pcscase,
        product_quantity: this.state.product_quantity,
        price_item: this.state.price_item,
        rimbursimi: this.state.rimbursimi,
        pa: this.state.pa,
        categories: this.state.categories,
        zbritje: this.state.zbritje,
        tvsh: this.state.tvsh,
        skadenca: this.state.skadenca,
        parent_category: this.state.parent_category,
        is_active: this.state.is_active,
      }
    })
    .then(_ => {
      if (this.props.product.status === 'created') {
        this.setState({
          openSnackBar: true
        })
      } else {
        this.setState({
          hasError: true,
        })
      }
    })
  }

  _handleClearInput = event => {
    this.setState({

    })
  }

  _handleRequestClose = () => {
    this.setState({
      openSnackBar: false,
    });
  };

  componentDidMount() {

  }

  render() {
    return (
      <form onSubmit={this._handleSubmit}>
      <Container>
        <FormContainer >
          <FormGroup>
            <FormTitle>Add Product</FormTitle>
          </FormGroup>
          <div>
            <TextField
              fullWidth
              required
              id="product_code"
              name="product_code"
              floatingLabelText="Product Code"
              value={this.state.product_code}
              onChange={this._handleChange}
            />
          </div>
          <div>
            <TextField
              fullWidth
              required
              id="product_name"
              name="product_name"
              floatingLabelText="Product Name"
              value={this.state.product_name}
              onChange={this._handleChange}
            />
          </div>
          <div>
            <TextField
              fullWidth
              required
              id="pcscase"
              name="pcscase"
              floatingLabelText="Pcscase"
              value={this.state.pcscase}
              onChange={this._handleChange}
            />
          </div>
          <div>
            <TextField
              required
              id="product_quantity"
              name="product_quantity"
              type="number"
              floatingLabelText="Product Quantity"
              value={this.state.product_quantity}
              onChange={this._handleChange}
              onBlur={this._handleBlur}
            />
          </div>
          <div>
            <TextField
              fullWidth
              required
              id="price_item"
              name="price_item"
              type="number"
              floatingLabelText="Price Item"
              value={this.state.price_item}
              onChange={this._handleChange}
              onBlur={this._handleBlur}
            />
          </div>
          <div>
            <TextField
              fullWidth
              required
              id="rimbursimi"
              name="rimbursimi"
              floatingLabelText="Rimbursimi"
              value={this.state.rimbursimi}
              onChange={this._handleChange}
            />
          </div>
          <div>
            <TextField
              fullWidth
              required
              id="pa"
              name="pa"
              floatingLabelText="Pa"
              value={this.state.pa}
              onChange={this._handleChange}
            />
          </div>
          <div>
            <TextField
              fullWidth
              required
              id="categories"
              name="categories"
              floatingLabelText="Categories"
              value={this.state.categories}
              onChange={this._handleChange}
            />
          </div>
          <div style={{ display: 'flex', alignItems: 'center'}}>

            <TextField
              style={{ width: '50px', marginRight: '16px' }}
              required
              id="zbritje"
              name="zbritje"
              type="number"
              floatingLabelText="Zbritje"
              value={this.state.zbritje}
              onChange={this._handleChangeZbritje}
              onBlur={this._handleBlur}
            />
            <Slider style={{ flex: 1, maxWidth: '200px' }} sliderStyle={{ marginBottom: '4px'}} step={0.0001} value={this.state.zbritje / 100} onChange={this._handleSliderChange} max={1}/>

          </div>
          <div>
            <TextField
              required
              id="tvsh"
              name="tvsh"
              floatingLabelText="Tvsh"
              value={this.state.tvsh}
              onChange={this._handleChange}
            />
          </div>
          <div>
            <div style={{position: 'relative', width: '260px'}}>
              <DatePicker
                floatingLabelText="Skadenca"
                container="inline"
                onChange={(event, date) => {this.setState({ skadenca: `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`})}}
                formatDate={date => `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`}/>
                <IconButton tooltip="Text Hint" style={{position: 'absolute', right: '0', bottom: '2px'}}>
                  <SvgIcon >
                    <path d="M0 0h24v24H0z" fill="none"/>
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>
                  </SvgIcon>
                </IconButton>
            </div>
          </div>
          <div style={{position: 'relative'}}>
            <TextField
              fullWidth
              required
              id="parent_category"
              name="parent_category"
              floatingLabelText="Parent Category"
              value={this.state.parent_category}
              onChange={this._handleChange}
            />
            <IconButton tooltip="Text Hint" style={{position: 'absolute', right: '0', bottom: '4px'}}>
              <SvgIcon >
                <path d="M0 0h24v24H0z" fill="none"/>
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>
              </SvgIcon>
            </IconButton>
          </div>
          <FormGroup>
            <Checkbox
              label="is Active"
              id="is_active"
              name="is_active"
              checked={this.state.is_active}
              onCheck={this._handleCheck}
            />
          </FormGroup>
          <FormGroup >
            <RaisedButton type='submit' label="Create" primary={true} />
            <RaisedButton style={{marginLeft: '16px'}} label="Remove" labelStyle={{color: 'white'}}  backgroundColor="#F44336" onTouchTap={this._handleClearInput}/>
          </FormGroup>
          <Snackbar
            open={this.state.openSnackBar}
            message="Product added successfully!"
            autoHideDuration={3000}
            onRequestClose={this._handleRequestClose}
          />
          {this.state.hasError &&
            <FormGroup>
              <Pre>
                <Code>
                  {`${JSON.stringify(this.props.product.error, undefined, 2)}`}
                </Code>
              </Pre>
            </FormGroup>
          }
        </FormContainer>
      </Container>
      </form>
    );
  }
}





const mapStateToProps = state => ({ product: state.product.created });
const mapDispatchToProps = { addProduct };
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CreateProduct));



// WEBPACK FOOTER //
// ./src/components/Products/CreateProduct.js